import React from 'react'
import TextField from '@material-ui/core/TextField'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
  width: {
    minWidth: '100%'
  }
})

export interface InputProps {
  label: string;
  onChange: (value: string) => void;
  value: string;
  error?: boolean;
  disabled?: boolean;
}

export const Input: React.FC<InputProps> = function (props) {
  const { label, value, onChange, error = false, disabled = false } = props
  const styles = useStyles()
  return (
    <TextField disabled={disabled} label={label} value={value} onChange={e => onChange(e.target.value)} error={error} className={styles.width} />
  )
}

export const RequiredInput: React.FC<InputProps> = function (props) {
  const { label, value, onChange, error = false, disabled = false } = props
  const styles = useStyles()
  return (
    <TextField disabled={disabled} label={label} value={value} onChange={e => onChange(e.target.value)} required error={error} className={styles.width} helperText={error && 'To pole jest wymagane.'} />
  )
}
